import { Routes, Route } from "react-router-dom";
import { Roles } from "@/pages/Roles/Roles";

export const RolesRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Roles />} />
        </Routes>
    );
};
